import Axios, { AxiosRequestConfig, AxiosResponse, Method } from 'axios';

import AxiosHttpClient from '~src/httpClient/AxiosHttpClient';
import { IRequest } from '~src/httpClient/serverApi/types/IRequest';
import { IResult } from '~src/httpClient/serverApi/types/IResponse';


/* NOTE: This is a temporary client used to test things locally. Will update this once we have the backend and APIs working */
namespace CustomDomainHttpClient {
    export function requestPutOrPost<TParams, TResult extends IResult>(request: IRequest<TParams, TResult>): Promise<TResult> {
        return   AxiosHttpClient.makeAxiosRequest<TResult>({
          method: request.method as Method,
          url: 'api/-/customdomains/settings/site/c3757a76-d0b2-4628-9ec3-ff1d9fde23dc',
          data: request.params,
          headers: request.headers
        });
      }

      export function requestGet<TParams, TResult extends IResult>(request: IRequest<TParams, TResult>): Promise<TResult> {
        return requestViaTag({
          method: request.method as Method,
          baseURL: 'http://localhost:8090',
          url: 'api/-/customdomains/settings/site/c3757a76-d0b2-4628-9ec3-ff1d9fde23dc',
          headers: request.headers
        });
      }

      export function requestDelete<TParams, TResult extends IResult>(request: IRequest<TParams, TResult>): Promise<TResult> {
        return   AxiosHttpClient.makeAxiosRequest<TResult>({
          method: request.method as Method,
          url: 'api/-/customdomains/settings/site/c3757a76-d0b2-4628-9ec3-ff1d9fde23dc',
          data: request.params,
          headers: request.headers
        });
      }

      function requestViaTag<TResult extends IResult>(requestConfig: AxiosRequestConfig): Promise<TResult> {
        return Axios(requestConfig).then(
          (successResponse: AxiosResponse<TResult>) => {
            return successResponse.data;
          }
        );
      }
}

export default CustomDomainHttpClient;